export default "__VITE_ASSET__BK9qDy9b__"